import React from 'react';
import { useOpeningHours } from '../contexts/OpeningHoursContext';
import { isCurrentlyOpen } from '../utils/checkOpenStatus';

const OpenStatusBadge: React.FC = () => {
  const { openingHours, loading } = useOpeningHours();

  if (loading) {
    return null;
  }

  const isOpen = isCurrentlyOpen(openingHours);

  return (
    <div className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-semibold" style={{ textShadow: '0 2px 4px rgba(0, 0, 0, 0.9), 0 1px 2px rgba(0, 0, 0, 0.9)' }}>
      <span className={`${isOpen ? 'text-green-400' : 'text-red-400'}`}>●</span>
      <span className="text-white">{isOpen ? 'Open Now' : 'Closed Now'}</span>
    </div>
  );
};

export default OpenStatusBadge;

